var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notifications),function(item,idx){return _c('snackbar',{key:item.id,attrs:{"index":idx,"item":item},on:{"remove":_vm.onRemove}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }